export default {
	methods: {
		downloadJSON(info: any, name: string) {
			const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(info, null, "\t"));
			const downloadElement = document.createElement("a");
			// @ts-ignore
			downloadElement.setAttribute("href", dataStr);
			// @ts-ignore
			downloadElement.setAttribute("download", name);
			// @ts-ignore
			downloadElement.click();
		}
	}
}
